import { Auth, getAuth } from '@firebase/auth';
import { initializeApp } from '@firebase/app';
import { staticConfig } from '@/config';

const app = initializeApp(staticConfig.firebase.config);

export const getFirebaseAuth = (): Auth => {
  const auth = getAuth(app);
  auth.languageCode = 'ja';
  auth.tenantId = staticConfig.tenantId;
  return auth;
};

export const getIdToken = async () => await getFirebaseAuth().currentUser?.getIdToken(true);
